import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';

export function FirebaseQueryProvider({ children }: { children: any }) {
  const [queryClient] = useState(() => {
    const client = new QueryClient({
      defaultOptions: {
        queries: {
          // 1. TIEMPO DE VIDA
          staleTime: 1000 * 60 * 5, // 5 minutos (Datos "frescos" por 5 min)
          gcTime: 1000 * 60 * 60, // 1 hora (Basura: Borrar de memoria tras 1 hora inactivo)

          // 2. DISPARADORES (Triggers)
          refetchOnWindowFocus: true, // No recargar al cambiar de pestaña
          refetchOnReconnect: true, // Sí recargar al recuperar internet
          refetchOnMount: true, // Sí recargar al volver a montar el componente (si está stale)

          // 3. REINTENTOS (Errores)
          retry: 2, // Si falla, intenta 1 vez más antes de mostrar error
        },
        mutations: {
          // Configuración por defecto para mutations (POST/PUT)
          retry: 2, // No reintentar si falla un POST
        },
      },
    });

    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools
        initialIsOpen={false}
        position="bottom"
        buttonPosition="top-right"
      />
      {children}
    </QueryClientProvider>
  );
}
